module.exports = __webpack_public_path__ + "static/media/A1_Sports_DRAGON_BROWN.d480e2fa.png";